const DataTableMixin = {
    data() {
        return {
            page: 1,
            totalPages: 1,
            next: null,
            pageSize: 10,
            previous: null,
            items: [],
            count: 0
        };
    },
    watch: {
        page() {
            this.getItems();
        }
    },

    methods: {
        formQueryParams() {
            return {
                page: this.page
            };
        },
        formalizeTable(data) {
            // this.page=response.current_page
            // this.totalPages=response.total_pages
            this.items = data.response;
            this.count = data.response.length;
        }
    }
};
export default DataTableMixin;